/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CloudConnection,
    CloudConnectionFromJSON,
    CloudConnectionFromJSONTyped,
    CloudConnectionToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetCloudLink
 */
export interface AssetCloudLink {
    /**
     * 
     * @type {number}
     * @memberof AssetCloudLink
     */
    id: number;
    /**
     * 
     * @type {CloudConnection}
     * @memberof AssetCloudLink
     */
    connection: CloudConnection;
    /**
     * 
     * @type {string}
     * @memberof AssetCloudLink
     */
    readonly presignedAssetUrl: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetCloudLink
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof AssetCloudLink
     */
    asset: number;
}

export function AssetCloudLinkFromJSON(json: any): AssetCloudLink {
    return AssetCloudLinkFromJSONTyped(json, false);
}

export function AssetCloudLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetCloudLink {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'connection': CloudConnectionFromJSON(json['connection']),
        'presignedAssetUrl': json['presigned_asset_url'],
        'createdAt': (new Date(json['created_at'])),
        'asset': json['asset'],
    };
}

export function AssetCloudLinkToJSON(value?: AssetCloudLink | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'connection': CloudConnectionToJSON(value.connection),
        'asset': value.asset,
    };
}


